var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-2"},_vm._l((_vm.enrichedChildren),function(child){return _c('div',{key:child.title},[(child.display)?_c(child.component,_vm._b({tag:"component",staticClass:"mb-2"},'component',child.props,false)):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }